import React from 'react';
import { ThirtyText, TextBold16 } from "@/app/components/texts";
import Input from "@/app/components/input";
import Button from "@/app/components/button";
import BottomSheet from "@/app/components/bottom_sheet/widget";
import Dialog from "@/app/components/dialog/widget";
import LazyAssets from "@/app/utils/assets_widget";
import { t } from "i18next";
import { s } from "@/app/utils/s";
import styles from "./styles.module.scss";

interface ReviewFormProps {
  isOpen: boolean;
  onClose: () => void;
  onSetReview: (review: string) => void;
  setRating: (rating: number) => void;
  sendReview: () => void;
  review: string;
  rating: number;
  isLoading: boolean;
  isDesktop: boolean;
}

const ReviewForm: React.FC<ReviewFormProps> = ({
  isOpen,
  onClose,
  onSetReview,
  setRating,
  sendReview,
  review,
  rating,
  isLoading,
  isDesktop
}) => {
  const content = (
    <div className={styles.review}>
      <ThirtyText text={t(s.leaveAReview)}/>
      <Input 
        onChange={onSetReview} 
        label={t(s.describeYourExperience)}
        hint={t(s.text)}
        className={styles.inputAboutMe}
        limit={200} 
        isTextArea
      />
      <div className={styles.block}>
        <TextBold16 text={t(s.rateCourts)}/>
        <div className={styles.ratings}>
          {[1, 2, 3, 4, 5].map((c) => (
            <div 
              className={styles.rating} 
              key={c + 5}
              onClick={() => setRating(c)}
            >
              {rating >= c ? 
                <LazyAssets.Star key={c} className={styles.star}/> :
                <LazyAssets.StarEmpty key={c} className={styles.star}/>
              }
            </div>
          ))}
        </div>
      </div>
      <Button 
        text={t(s.send)} 
        onClick={sendReview}
        isDisabled={review.length <= 1 || rating === 0}
        isLoading={isLoading}
      />
    </div>
  );

  return isDesktop ? (
    <Dialog open={isOpen} onClose={onClose}>
      {content}
    </Dialog>
  ) : (
    <BottomSheet open={isOpen} onClose={onClose}>
      {content}
    </BottomSheet>
  );
};

export default ReviewForm;